import { URL_REPLACEMENT } from '$const';
import { CropDownloadDto } from '~modules/media-library/model/CropFormat';
import { get } from '~services/api/methods';

export async function fetchCropFormats(assetId: string) {
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/mamlibrary/crop_formats/${assetId}`;
  const response = await get(requestUrl);
  return response;
}

export async function fetchCroppedFormat({ assetId, x0, y0, x1, y1, width, height }: CropDownloadDto) {
  const MAM_PREFIX = '-';
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/mamlibrary/cropper/${MAM_PREFIX}${assetId}/${x0}/${y0}/${x1}/${y1}/${width}/${height}`;
  const response = await get(requestUrl);
  return response;
}
